import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.UPSERT_ADDRESS_SUCCESS:
      return action.address;
    case actionTypes.FETCH_ADDRESS_SUCCESS:
      return action.address;
    default:
      return state;
  }
}
